// src/components/ProtectedRoute.tsx
import React, { useContext } from "react";
import { Navigate } from "react-router-dom";
import { UserAuthenticationContext } from "../Context/UserAuthenticationContext";
import { ALLOWED_REPORTING_USERS } from "../reportsconfig";

interface ProtectedRouteProps {
  children: JSX.Element;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const { userData, authInitializing } = useContext(UserAuthenticationContext);
  const userId = userData?.id;

  // Don't decide while the auth bootstrap is still running on a fresh load —
  // userData isn't populated yet and redirecting here is the main cause of the
  // "logged out on refresh" flap on slow connections.
  if (authInitializing) {
    return null;
  }

  // If there's no user or the user is not in the allowed list, redirect.
  if (!userId || !ALLOWED_REPORTING_USERS.includes(userId)) {
    return <Navigate to="/login" replace />;
  }

  return children;
};

export default ProtectedRoute;
